import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const TaskAlt = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.8337 10.7919L22.0625 34.5838L13.2293 25.75L16.1668 22.8125L22.0625 28.7081L42.8962 7.87501L45.8337 10.7919ZM41.2293 21.2919C41.996 24.6593 41.697 28.1817 40.3736 31.3717C39.0502 34.5616 36.768 37.2613 33.8427 39.0971C30.9174 40.9328 27.4939 41.8139 24.0459 41.6183C20.5978 41.4226 17.2959 40.16 14.597 38.0052C11.8982 35.8503 9.93594 32.9098 8.98186 29.5906C8.02779 26.2715 8.12908 22.7378 9.27173 19.4787C10.4144 16.2197 12.5418 13.3964 15.3597 11.3997C18.1775 9.40295 21.5464 8.33155 25 8.33376C28.1603 8.32982 31.2552 9.23356 33.9168 10.9375L36.9168 7.93751C33.4302 5.47827 29.2666 4.16088 25 4.16688C20.5564 4.15522 16.2249 5.56087 12.635 8.17956C9.04502 10.7982 6.38368 14.4935 5.03771 18.7283C3.69175 22.9631 3.7313 27.5168 5.15062 31.7276C6.56994 35.9384 9.29506 39.5869 12.93 42.1428C16.5649 44.6988 20.9201 46.029 25.3628 45.9401C29.8055 45.8513 34.1041 44.348 37.6339 41.6488C41.1637 38.9496 43.7408 35.1951 44.9906 30.9309C46.2404 26.6668 46.0979 22.1151 44.5837 17.9375L41.2293 21.2919Z"
        fill={color}
      />
    </svg>
  )
}
